import { baseMethods,  } from '..'
import { User } from '../auth';
import { DataMapping, Integration } from '../integration/admin';
import * as admin from './admin'

export interface Automation {
  type: 'LETTER' | 'CSV_DOWNLOAD' | 'EMAIL' | 'REQUEST',
  letter?: {
    templateFileId: string;
    requiresCurrentStepData: boolean;
    name: string
    letterPerItem?: boolean;
  }
  csvDownload?: {
    fileName: string;
    dataMapping: DataMapping[]
  }
  email?: {
    name: string;
    requiresCurrentStepData: boolean;
    to: string;
    cc: string;
    subject: string;
    body: string;
    includeLinkToCase: boolean;
    emailPerItem?: boolean;
    attachments?: { name: string }[]
  }
}

export type AgentConfig = {
  enabledTools: {toolId: string, hardcodedArgs: Record<string, any>}[]
  enabled?: boolean
}

export type ItemField = {
  label?: string;
  name: string;
  type: 'text' | 'number' | 'date' | 'select' | 'textarea' | 'file' | 'select' | 'formula' | 'currency' | 'checkbox'
  options?: { value: string, label: string}[]
  requiredOnCreate?: boolean
  formula?: string
  maxLength?: number
  minLength?: number
  oftenRefferedToAs?: string
  description?: string
  defaultValue?: string
}

export type MapPosition = {
  x: number;
  y: number;
}

export type PreviousStep = {
  id: string;
  stepEdge: 'top' | 'left' | 'right' | 'bottom';
  previousStepEdge: 'top' | 'left' | 'right' | 'bottom';
  /** used when a step is linked to a decision to represent the decision made - usually "Yes" or "No" */
  label?: string
}

export type ProcessStepRisks = {
  id: string;
  processStepId: string;
  description: string;
  preMitigationRag: string;
  postMitigationRag?: string;
  mitigationDescription?: string;
  mitigationStatus?: 'UNMITIGATED' | 'AWAITING_IMPLEMENTATION' | 'IMPLEMENTED';
  mitigationDate?: Date;
}

export type Step = {
  id: string;
  taxonomyLabel?: string;
  name: string;
  description: string | null;
  guidanceNotes?: string;
  type: string;
  stepNumber: number;
  track: number;
  autoComplete: boolean;
  autoDecisionFormula?: string;
  previousStepIds?: string[];
  dueInDays?: number;
  dueInSentence?: string;
  previousStepLabel?: string;
  nextStepIds: string[] | null;
  processId: string;
  companyId: string;
  current?: boolean;
  supportingData?: ItemField[]
  controlOutcome?: 'PASS' | 'FAIL';
  ownerGroups: string[];
  automation?: Automation;
  agent?: AgentConfig;
  mapPosition?: MapPosition;
  previousSteps?: PreviousStep[];
  requireProcessItemsHere?: boolean;
  risks?: ProcessStepRisks[];
}

export type ItemLookupIntegration = {
  id: string
  integrationType: 'DEMO' | 'HIBOB',
  lookupItemFieldName: string
  dataMappings: DataMapping[]
}

export type Process = {
  id: string;
  taxonomyLabel?: string;
  name: string;
  category?: string;
  published: boolean;
  allowMoveBackSteps?: boolean;
  allowCaseDueDateUpdate?: boolean;
  dueInSentence?: string;
  description: string | null;
  itemName: string;
  itemDisplayField: string;
  itemFields: ItemField[];
  supportingData: ItemField[];
  ownerGroups: string[];
  companyId: string;
  integrations: Integration[];
  steps: Step[];
  maxItems?: number
  ownerId?: string;
  owner?: User;
  itemLookupIntegration?: ItemLookupIntegration
}

export const get = (id: string) => {
  return baseMethods.get<Process>({
    path: `/process/${id}`,
  })
}

export const list = async () => {
  return baseMethods.get<Process[]>({
    path: `/process`,
  })
}

export { admin }